import { useState } from "react";

export default function usePreStartQuestionModalState() {
  const [questionModalVisible, setQuestionModalVisible] = useState(false);
  const [questionModalMode, setQuestionModalMode] = useState("add");
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(null);

  const closeQuestionModal = () => {
    setQuestionModalVisible(false);
    setSelectedQuestionIndex(null);
  };

  const openAddQuestionModal = ({ disabled = false } = {}) => {
    if (disabled) {
      return;
    }

    setQuestionModalMode("add");
    setSelectedQuestionIndex(null);
    setQuestionModalVisible(true);
  };

  const openEditQuestionModal = (index, { disabled = false } = {}) => {
    if (disabled) {
      return;
    }

    setQuestionModalMode("edit");
    setSelectedQuestionIndex(index);
    setQuestionModalVisible(true);
  };

  return {
    questionModalVisible,
    questionModalMode,
    selectedQuestionIndex,
    closeQuestionModal,
    openAddQuestionModal,
    openEditQuestionModal
  };
}
